// src/services/refundApi.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/payments";

const setTokenHeader = () => {
  const token = localStorage.getItem("adminToken");
  if (token) axios.defaults.headers.common["Authorization"] = token;
  else delete axios.defaults.headers.common["Authorization"];
};

const refundApi = {
  // New name
  getOrderPaymentInfo: (orderId) => {
    setTokenHeader();
    return axios.get(`${BASE_URL}/refunds/order/${orderId}`, { withCredentials: true });
  },

  // ✅ Backward-compatible old name
  getOrderPaymentDetails: (orderId) => {
    return refundApi.getOrderPaymentInfo(orderId);
  },

  createRefund: (payload) => {
    setTokenHeader();
    return axios.post(`${BASE_URL}/refunds/create`, payload, { withCredentials: true });
  },

  listRefunds: (orderId) => {
    setTokenHeader();
    return axios.get(`${BASE_URL}/refunds/list/${orderId}`, { withCredentials: true });
  },

  // ✅ New: list all refunds (server pagination)
  listAllRefunds: (params) => {
    setTokenHeader();
    return axios.get(`${BASE_URL}/refunds`, { params, withCredentials: true });
  },

  reconcileRefund: (refundId) => {
    setTokenHeader();

    return axios.post(
      `${BASE_URL}/refunds/${refundId}/reconcile`,
      {},
      {
        withCredentials: true,
      }
    );
  },
};

export default refundApi;
